/**
 * Procedural sample artwork for the hero and portfolio previews, so the
 * landing page shows the real print renderer without stock imagery.
 */
export function createSampleArtwork(variant: 'fig' | 'citrus' | 'noir' = 'fig'): HTMLCanvasElement {
  const W = 2000;
  const H = 500;
  const c = document.createElement('canvas');
  c.width = W;
  c.height = H;
  const ctx = c.getContext('2d')!;

  const palettes = {
    fig: { a: '#0098d4', b: '#d4006f', c: '#f2c500', text: '#1b1f22', name: 'FIG & CEDAR', sub: 'SCENTED CANDLE · 300 ML' },
    citrus: { a: '#f2a100', b: '#e2462b', c: '#2f9e5c', text: '#1b1f22', name: 'NEROLI 04', sub: 'SOY WAX · HAND POURED' },
    noir: { a: '#c9a24a', b: '#e8d9b5', c: '#8a6d2f', text: '#f4efe2', name: 'AMBER NOIR', sub: 'LIMITED EDITION' },
  } as const;
  const p = palettes[variant];

  // Halftone waves — three process colours at offset screen angles.
  ctx.globalCompositeOperation = variant === 'noir' ? 'source-over' : 'multiply';
  const layers: [string, number, number][] = [
    [p.a, 0, 0],
    [p.b, 1.9, 60],
    [p.c, 3.7, 120],
  ];
  for (const [color, phase, yOff] of layers) {
    ctx.fillStyle = color;
    for (let x = 12; x < W; x += 22) {
      for (let y = 12; y < H; y += 22) {
        const wave = Math.sin(x / 140 + phase) * 0.5 + Math.cos((y + yOff) / 90 + x / 400) * 0.5;
        const r = Math.max(0, wave) * 8.5;
        if (r < 0.8) continue;
        ctx.beginPath();
        ctx.arc(x + (yOff % 11), y, r, 0, Math.PI * 2);
        ctx.fill();
      }
    }
  }

  // Label panel on the front.
  ctx.globalCompositeOperation = 'source-over';
  const lx = W / 2 - 330;
  const ly = 95;
  ctx.fillStyle = variant === 'noir' ? '#15171a' : '#fbfaf7';
  ctx.fillRect(lx, ly, 660, 310);
  ctx.strokeStyle = p.text;
  ctx.lineWidth = 3;
  ctx.strokeRect(lx + 14, ly + 14, 632, 282);
  ctx.fillStyle = p.text;
  ctx.textAlign = 'center';
  ctx.font = '600 30px "JetBrains Mono Variable", "JetBrains Mono", monospace';
  ctx.fillText('RDK · N° 017', W / 2, ly + 80);
  ctx.font = '700 76px "Unbounded Variable", "Unbounded", "Arial Black", sans-serif';
  ctx.fillText(p.name, W / 2, ly + 180);
  ctx.font = '500 28px "Onest Variable", "Onest", system-ui, sans-serif';
  ctx.fillText(p.sub, W / 2, ly + 240);
  return c;
}
